export default (props, vars) =>
  vars?.['applicationcard2']?.['item'].all_steps.findIndex(
    ({ stage }) =>
      stage === vars?.['applicationcard2']?.['item'].current_step.stage
  ) + 1;
